import * as types from '../../constants/log/powerChargeLogConstants';

export const powerChargeLogListRequest = (
  {
    page,
    pageLength,
    beginDate,
    endDate,
    searchString,
    callback,
    error
  }
) => ({
  type: types.POWERCHARGELOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  searchString,
  callback,
  error
});

export const powerChargeLogList = (list) => ({
  type: types.POWERCHARGELOG_LIST,
  list
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setPowerChargeLogPagination = (
  page, totalCount, beginDate, endDate, searchCode, searchString
) => ({
  type: types.SET_POWERCHARGELOG_PAGINATION,
  page,
  totalCount,
  beginDate,
  endDate,
  searchCode,
  searchString,
});

export const powerChargeLogPageReset = () => ({
  type: types.POWERCHARGELOG_PAGE_RESET,
});
